import React, { FC, useMemo } from 'react'

import { Navigate } from 'react-router-dom'
import { Routes } from 'common/constants'

import { PrivacyPolicyAcceptanceView } from './PrivacyPolicyAcceptanceView'
import { usePrivacyPolicyAcceptance } from '../hooks'
import { PrivacyPolicyAcceptanceSkeleton } from './PrivacyPolicyAcceptanceSkeleton'

export const PrivacyPolicyAcceptance: FC = () => {
  const {
    isLoading,
    isLoadingPending,
    isError,
    isSuccess,
    title,
    menuItemIconRef,
    checkBoxCommonText,
    checkBoxState,
    confirmButton,
    terms,
    successFeedbackPage,
    errorFeedbackPage,
    isEmpty,
    emptyPage,
    deeplinks,
    checkBoxHandler,
    menuItemButtonHandler,
    onClickLeftIcon,
  } = usePrivacyPolicyAcceptance()

  const successNavigateState = useMemo(
    () => ({
      content: successFeedbackPage,
      deeplink: deeplinks?.globalAccountHome,
    }),
    [successFeedbackPage, deeplinks?.globalAccountHome],
  )

  const errorNavigateState = useMemo(
    () => ({
      content: errorFeedbackPage,
    }),
    [errorFeedbackPage],
  )

  const viewProps = useMemo(
    () => ({
      title,
      menuItemIconRef,
      checkBoxCommonText,
      checkBoxState,
      confirmButton,
      terms,
      isEmpty,
      emptyPage,
      isLoadingPending,
      checkBoxHandler,
      menuItemButtonHandler,
      onClickLeftIcon,
    }),
    [
      title,
      menuItemIconRef,
      checkBoxCommonText,
      checkBoxState,
      confirmButton,
      terms,
      isEmpty,
      emptyPage,
      isLoadingPending,
      checkBoxHandler,
      menuItemButtonHandler,
      onClickLeftIcon,
    ],
  )

  if (isLoading) return <PrivacyPolicyAcceptanceSkeleton />

  if (isSuccess) {
    return <Navigate to={Routes.PRIVACY_POLICY_ACCEPTANCE_SUCCESS} state={successNavigateState} />
  }

  if (isError) {
    return <Navigate to={Routes.PRIVACY_POLICY_ACCEPTANCE_ERROR} state={errorNavigateState} />
  }

  return <PrivacyPolicyAcceptanceView {...viewProps} />
}
